
import { Component, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import AuthMixin from "@/common/mixins/auth.mixin";
import { LoginFormDto } from "@/types/user.type";
import { ErrorType, Roles } from "@/types/enums.type";
import ValidatedFormMixin from "@/common/mixins/validated-form.mixin";

@Component({
  computed: {
    ...mapState("Auth", ["errorMessage", "errorType"])
  }
})
export default class Login extends Mixins(AuthMixin, ValidatedFormMixin) {
  loginDto: LoginFormDto = new LoginFormDto();
  passwordShow = false;
  loading = false;

  errorMessage!: string;
  errorType!: ErrorType | null;

  ErrorType = ErrorType;

  viewPassword(): void {
    this.passwordShow = !this.passwordShow;
  }

  async submit(): Promise<void> {
    this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.loading = true;

        await this.$store.dispatch("Auth/login", this.loginDto);

        if (!this.userInfo()) {
          this.loading = false;
          return;
        }

        this.loading = false;
        if (this.userInfo()?.role === Roles.CustomerSupport) {
          this.$router.push("/customer-support/dashboard");
        } else if (!this.userInfo()?.isWizardComplete && this.userInfo()?.role === Roles.PracticeUser) {
          this.$router.push("/wizard");
        } else {
          this.$router.push("/shifts");
        }
      }
    });
  }

  async resendConfirmation(): Promise<void> {
    await this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.loading = true;

        await this.$store.dispatch("Auth/resendConfirmation", this.loginDto);

        this.loading = false;
      }
    });
  }
}
